import { observable, action } from 'mobx';
import agent from '../agent';
import userStore from './userStore';
//import commonStore from './commonStore';
//import websocketStore from './websocketStore';
//import { common } from '@material-ui/core/colors';
//import { convertColorToString } from 'material-ui/utils/colorManipulator';

export class FeedbackStore {
    @observable inProgress = false;
    @observable feedbackResponse;
    @observable errors;
    @observable statusText;
    @observable openFeedbackDialog = false;

    @action sendFeedback(type, tempId, feedbackText, stars) {
        this.statusText = '';
        this.errors = undefined;
        this.inProgress= true;
        return agent.Feedback.sendFeedback(type, tempId, feedbackText, stars)
            .then(action((response) => {
                this.feedbackResponse = response;
                this.openFeedbackDialog = true;
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.inProgress = false
            }))
    }

    @action closeFeedbackDialog() {
        this.openFeedbackDialog = false;
    }

}

export default new FeedbackStore();
